import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import DisplayCard from "../component/DisplayCard";
import Toppers from "../data/Toppers.json";
import IconButton from "@mui/material/IconButton";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
import { useSelector } from "react-redux";
// import Swipper from "../component/Swipper";

// const images = [
//       'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
//       'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
//       'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250',
//       'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
//       '/Images/ravi-sir.jpg'
// ]

const Home = () => {
  const userProfile = useSelector((state) => state.userProfile);
  React.useEffect(() => {
    console.log("userProfile :: ", userProfile);
  }, [userProfile]);
  return (
    <Container sx={{ marginTop: "100px", marginBottom: "25px" }}>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <DisplayCard data={Toppers[0]} />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: "1000" }}>
            S R Classes
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: "25px", fontWeight: "1000", mt: 2 }}
          >
            Near SVM Sultanpur
          </Typography>
          <img
            src="/Images/ravi-sir.jpg"
            alt="hero-section"
            style={{
              height: 300,
              width: 300,
              objectFit: "cover",
              borderRadius: "50%",
              marginTop: "20px",
            }}
          />
          <Typography
            variant="body1"
            sx={{ fontWeight: "1000", fontSize: "20px", mt: 2 }}
          >
            Admision Open
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontWeight: "1000", fontSize: "20px", mt: 2 }}
          >
            Contact +91 82996 65230
          </Typography>
          <div
            style={{
              // border: '2px solid red',
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignContent: "center",
              marginTop: "20px",
            }}
          >
            <a href="tel:+918299665230">
              <IconButton
                sx={{
                  border: "2px solid black",
                  height: "80px",
                  width: "80px",
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: "700", mt: 1 }}>
                  <CallIcon sx={{ fontSize: "40px" }} />
                </Typography>
              </IconButton>
            </a>
            <a href="https://wa.me/+918299665230">
              <IconButton
                sx={{
                  border: "2px solid black",
                  height: "80px",
                  width: "80px",
                }}
              >
                <Typography variant="body1" sx={{ fontWeight: "700", mt: 1 }}>
                  <WhatsAppIcon sx={{ fontSize: "40px" }} />
                </Typography>
              </IconButton>
            </a>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <DisplayCard data={Toppers[1]} />
        </Grid>
      </Grid>
      {/* <Grid container sx={{
            justifyContent: 'center',
            alignItems: 'center'
          }} >
      <Grid 
      item
        style={{ 
          overflow: 'hidden', 
          maxWidth:'800px', 
          borderRadius:'15px', 
          height:'300px', 
          boxShadow:'3px 4px 5px 3px whitesmoke', 
          margin:'10px'}}
          >
          <Swipper data={images} />
        </Grid>
        </Grid> */}
    </Container>
  );
};

export default Home;
